
import { Navigate, Route, Routes } from "react-router-dom"
import { LoginPage, RegisterPage, ForgotPasswordPage } from "../../pages/auth"

export const AuthRoutes = () => {

    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/reset-password" element={<ForgotPasswordPage />} />

            <Route path="*" element={<Navigate to='/auth/login' />} />
        </Routes>
    )
}
